import { Button, Typography, Box } from "@mui/material";
import threePerson from "../../assets/imgs/persons/threePersonConnection.png";
import ReplayIcon from "@mui/icons-material/Replay";
import { useTheme } from "@mui/material/styles";
export default function ErrorPageConnection({ error, resetErrorBoundary }) {
	const theme = useTheme();
	return (
		<div
			style={{
				margin: "0 auto",
				position: "fixed",
				width: "85vw",
				height: "100vh",
			}}
		>
			<svg
				viewBox="0 0 1642 900"
				xmlns="http://www.w3.org/2000/svg"
				style={{ width: "100%", height: "auto", position: "absolute" }}
			>
				<g clip-path="url(#clip0_1075_3444)">
					<rect
						width="1642"
						height="900"
						fill={theme.palette.background.wallpaper}
					/>
					<path
						d="M1353.81 92.8604C1317.56 53.5553 1347.53 -0.971266 1367.05 -23.3214L1834.76 -134.765C1896.2 -27.1016 1995.17 165.947 1899.51 76.8312C1779.95 -34.5634 1643.73 79.4346 1751 152.118C1858.28 224.801 1784.82 391.666 1718.97 312.012C1653.11 232.358 1647.48 241.2 1546.47 283.632C1445.46 326.065 1446.09 264.449 1450.59 173.042C1455.09 81.6353 1399.13 141.992 1353.81 92.8604Z"
						fill="url(#paint0_linear_1075_3444)"
					/>
					<path
						d="M361.17 1373.18C329.121 1445.19 246.161 1408.92 208.688 1381.78L-155.828 617.993C-49.88 484.96 145.465 265.425 79.2571 451.551C-3.50251 684.208 122.86 706.23 228.135 667.913C400.262 605.264 530.268 561.975 461.666 695.008C393.065 828.041 406.891 835.243 508.712 995.281C610.533 1155.32 530.317 1160.05 415.221 1185.65C309.943 1209.07 401.232 1283.15 361.17 1373.18Z"
						fill="url(#paint1_linear_1075_3444)"
					/>
					<path
						d="M271.216 168.448C266.992 168.448 263.109 167.467 259.568 165.504C256.027 163.499 253.211 160.747 251.12 157.248C249.072 153.707 248.048 149.717 248.048 145.28C248.048 140.843 249.072 136.875 251.12 133.376C253.211 129.835 256.027 127.083 259.568 125.12C263.109 123.157 266.992 122.176 271.216 122.176C275.483 122.176 279.365 123.157 282.864 125.12C286.405 127.083 289.2 129.835 291.248 133.376C293.296 136.875 294.32 140.843 294.32 145.28C294.32 149.717 293.296 153.707 291.248 157.248C289.2 160.747 286.405 163.499 282.864 165.504C279.323 167.467 275.44 168.448 271.216 168.448ZM271.216 156.8C274.416 156.8 276.933 155.755 278.768 153.664C280.645 151.573 281.584 148.779 281.584 145.28C281.584 141.696 280.645 138.88 278.768 136.832C276.933 134.741 274.416 133.696 271.216 133.696C267.973 133.696 265.435 134.741 263.6 136.832C261.765 138.88 260.848 141.696 260.848 145.28C260.848 148.821 261.765 151.637 263.6 153.728C265.435 155.776 267.973 156.8 271.216 156.8ZM316.663 168.448C313.079 168.448 309.858 167.701 306.999 166.208C304.183 164.715 301.964 162.581 300.343 159.808C298.722 157.035 297.911 153.771 297.911 150.016C297.911 146.304 298.722 143.061 300.343 140.288C302.007 137.515 304.247 135.381 307.063 133.888C309.922 132.395 313.143 131.648 316.727 131.648C320.311 131.648 323.511 132.395 326.327 133.888C329.186 135.381 331.426 137.515 333.047 140.288C334.711 143.061 335.543 146.304 335.543 150.016C335.543 153.728 334.711 156.992 333.047 159.808C331.426 162.581 329.186 164.715 326.327 166.208C323.468 167.701 320.247 168.448 316.663 168.448ZM316.663 157.568C318.412 157.568 319.863 156.928 321.015 155.648C322.21 154.325 322.807 152.448 322.807 150.016C322.807 147.584 322.21 145.728 321.015 144.448C319.863 143.168 318.434 142.528 316.727 142.528C315.02 142.528 313.591 143.168 312.439 144.448C311.287 145.728 310.711 147.584 310.711 150.016C310.711 152.491 311.266 154.368 312.375 155.648C313.484 156.928 314.914 157.568 316.663 157.568ZM353.191 137.088C354.172 135.424 355.559 134.101 357.351 133.12C359.143 132.139 361.255 131.648 363.687 131.648C366.545 131.648 369.127 132.395 371.431 133.888C373.777 135.381 375.612 137.515 376.935 140.288C378.3 143.061 378.983 146.304 378.983 150.016C378.983 153.728 378.3 156.992 376.935 159.808C375.612 162.581 373.777 164.715 371.431 166.208C369.127 167.701 366.545 168.448 363.687 168.448C361.255 168.448 359.143 167.957 357.351 166.976C355.601 165.995 354.215 164.672 353.191 163.008V185.152H340.647V132.096H353.191V137.088ZM366.247 150.016C366.247 147.669 365.607 145.856 364.327 144.576C363.089 143.253 361.553 142.592 359.719 142.592C357.884 142.592 356.327 143.253 355.047 144.576C353.809 145.899 353.191 147.712 353.191 150.016C353.191 152.363 353.809 154.197 355.047 155.52C356.327 156.843 357.884 157.504 359.719 157.504C361.553 157.504 363.089 156.843 364.327 155.52C365.607 154.155 366.247 152.32 366.247 150.016ZM399.443 168.448C396.2 168.448 393.299 167.915 390.739 166.848C388.221 165.739 386.216 164.245 384.723 162.368C383.272 160.448 382.461 158.293 382.291 155.904H394.451C394.621 157.056 395.155 157.952 396.051 158.592C396.947 159.232 398.056 159.552 399.378 159.552C400.403 159.552 401.213 159.339 401.811 158.912C402.408 158.485 402.707 157.931 402.707 157.248C402.707 156.352 402.216 155.691 401.235 155.264C400.253 154.837 398.632 154.368 396.371 153.856C393.811 153.344 391.677 152.768 389.97 152.128C388.264 151.488 386.771 150.443 385.491 148.992C384.253 147.541 383.635 145.579 383.635 143.104C383.635 140.971 384.211 139.051 385.363 137.344C386.515 135.595 388.2 134.208 390.419 133.184C392.68 132.16 395.389 131.648 398.547 131.648C403.24 131.648 406.931 132.8 409.619 135.104C412.307 137.408 413.864 140.437 414.291 144.192H402.963C402.749 143.04 402.237 142.165 401.427 141.568C400.659 140.928 399.613 140.608 398.291 140.608C397.267 140.608 396.477 140.8 395.923 141.184C395.411 141.568 395.155 142.101 395.155 142.784C395.155 143.637 395.645 144.299 396.627 144.768C397.608 145.195 399.187 145.643 401.363 146.112C403.965 146.667 406.12 147.285 407.827 147.968C409.576 148.651 411.091 149.76 412.371 151.296C413.693 152.789 414.354 154.837 414.354 157.44C414.354 159.531 413.736 161.408 412.499 163.072C411.304 164.736 409.576 166.059 407.315 167.04C405.096 167.979 402.472 168.448 399.443 168.448ZM437.29 120.576L435.818 151.104H425.13L423.658 120.576H437.29ZM430.506 168.512C428.287 168.512 426.495 167.915 425.13 166.72C423.807 165.483 423.146 163.925 423.146 162.048C423.146 160.171 423.807 158.613 425.13 157.376C426.495 156.139 428.287 155.52 430.506 155.52C432.682 155.52 434.431 156.139 435.753 157.376C437.119 158.613 437.802 160.171 437.802 162.048C437.802 163.883 437.119 165.419 435.753 166.656C434.431 167.893 432.682 168.512 430.506 168.512Z"
						fill="url(#paint2_linear_1075_3444)"
					/>
					<path
						d="M1599.73 774.875C1656.44 839.381 1593.98 916.614 1555.66 947.167L836 1051C747.226 880.086 743 746.893 743 712.5C743 446.812 891.5 769.961 891.5 637.961C891.5 422.14 895.286 260.756 996.833 390.32C1098.38 519.883 1109.88 507.478 1295.09 459.236C1480.3 410.995 1457.31 501.713 1442 639.461C1428 765.461 1528.84 694.243 1599.73 774.875Z"
						fill="url(#paint3_linear_1075_3444)"
					/>
					<rect
						x="891"
						y="409"
						width="549.585"
						height="514.078"
						fill="url(#pattern0_1075_3444)"
					/>
				</g>
				<text
					x={"250"}
					y={"230"}
					fill={theme.palette.text.main}
					fontSize={24}
					fontWeight={"bold"}
				>
					Ocorreu um erro no carregamento desta tela.
				</text>
				<text
					x={"250"}
					y={"270"}
					fill={theme.palette.text.main}
					fontSize={24}
					fontWeight={"bold"}
				>
					Por favor, tente novamente.
				</text>
				<foreignObject x="250" y="320" width="200" height="100">
					<Button
						onClick={resetErrorBoundary}
						sx={{
							color: theme.palette.white.main,
							background: `linear-gradient(90deg, ${theme.palette.buttonHoverGradient.dark} 0%, ${theme.palette.buttonHoverGradient.light} 100%)`,
						}}
						startIcon={<ReplayIcon />}
					>
						Recarregar
					</Button>
				</foreignObject>
				<defs>
					<pattern
						id="pattern0_1075_3444"
						patternContentUnits="objectBoundingBox"
						width="1"
						height="1"
					>
						<use
							xlinkHref="#image0_1075_3444"
							transform="matrix(0.000976562 0 0 0.00104401 0 -0.0345346)"
						/>
					</pattern>

					<linearGradient
						id="paint1_linear_1075_3444"
						x1="433.873"
						y1="1370.94"
						x2="73.7259"
						y2="381.448"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color={theme.palette.buttonHoverGradient.dark} />
						<stop
							offset="1"
							stop-color={theme.palette.buttonHoverGradient.light}
						/>
					</linearGradient>
					<linearGradient
						id="paint2_linear_1075_3444"
						x1="246"
						y1="146"
						x2="444"
						y2="146"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color={theme.palette.buttonHoverGradient.dark} />
						<stop
							offset="1"
							stop-color={theme.palette.buttonHoverGradient.light}
						/>
					</linearGradient>
					<linearGradient
						id="paint3_linear_1075_3444"
						x1="1622.5"
						y1="697.5"
						x2="743"
						y2="697.5"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color={theme.palette.buttonHoverGradient.dark} />
						<stop
							offset="1"
							stop-color={theme.palette.buttonHoverGradient.light}
						/>
					</linearGradient>
					<clipPath id="clip0_1075_3444">
						<rect width="1642" height="900" fill={theme.palette.white.main} />
					</clipPath>
					<image
						id="image0_1075_3444"
						width="1024"
						height="1024"
						preserveAspectRatio="none"
						href={threePerson}
					/>
				</defs>
			</svg>
		</div>
	);
}
